import axios from "axios";

const api = axios.create({
  // baseURL: `${process.env.REACT_APP_API}`, //`http://localhost:5000/api/`  //`https://motoland-backend.herokuapp.com/api/`
  baseURL: `https://motoland-backend.herokuapp.com/api/`, //`http://localhost:5000/api/`  //`https://motoland-backend.herokuapp.com/api/`
});

api.interceptors.request.use((request) => {
  try {
    const authUser = JSON.parse(localStorage.getItem("auth_user") || "{}");
    if (authUser?.iduser) {
      request.headers = request.headers || {};
      request.headers["x-user-id"] = authUser.iduser;
    }
  } catch (error) {
    // Si el usuario local esta corrupto, continuamos sin header de auditoria.
  }

  return request;
});

export default api;
